export enum THGCreateSource {
    /**
     * Enum representing the 'create source' (frontend app or crm).
     */
    USER_PORTAL = 'user-portal',
    CRM = 'crm',
    AUTO_RENEWAL = 'auto-renewal',
    EMOVY_IMPORT = 'emovy-import',
    BULK_IMPORT = 'bulk-import',
    RENEWAL_ACTION = 'renewal-action',
    RENEWAL = 'renewal',
}
